/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskObjectives } from './taskObjectives';

/**
 * Input to generate a rubric based on the task description and the task analysis result
 */
export interface RubricGenerationInput {
  taskAnalysis: TaskObjectives;
}
